import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreLabel?: string;
  moreTo?: string;
  icon?: string;
}

export default function SectionHeading({ title, subtitle, moreLabel, moreTo, icon }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div className="flex items-start gap-3">
        {icon && (
          <span className="mt-1 flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-600">
            <i className={`${icon} text-xl`} />
          </span>
        )}
        <div>
          <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
            {title}
          </h2>
          {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreLabel && moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium text-primary-600 transition-colors hover:bg-primary-50 hover:text-primary-700 cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      )}
    </div>
  );
}